import { Code, Text } from "@radix-ui/themes";
import { useQueryErrorResetBoundary } from "@tanstack/react-query";
import { ErrorComponent } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { ErrorPage } from "../../../components/ErrorPage";
import { errorMessage } from "../../../utils/http";

export const TicketsError: typeof ErrorComponent = ({
  error,
}: {
  error: Error | Response;
}) => {
  const queryErrorResetBoundary = useQueryErrorResetBoundary();
  const [message, setMessage] = useState<string>();

  useEffect(() => {
    if (error instanceof Response && error.status === 401) {
      setMessage("You are not authorized to access this folder.");
    } else {
      errorMessage(error).then(setMessage);
    }
  }, [error]);

  useEffect(() => {
    queryErrorResetBoundary.reset();
  }, [queryErrorResetBoundary]);

  return (
    <ErrorPage
      title="Error"
      description="Unable to retrieve tickets because an error occurred:"
      variant="error"
    >
      <Code
        color="red"
        data-testid="tickets-error-message"
        className="text-red-600"
      >
        {message}
      </Code>
      <Text
        color="red"
        data-testid="tickets-error-help-text"
        className="text-red-600"
      >
        Please try again shortly or contact support if the problem persists.
      </Text>
    </ErrorPage>
  );
};
